var canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

var isBrowser = canUseDOM();
export { canUseDOM, isBrowser };